import { Autocomplete, TextField } from "@mui/material";
import { ReactNode } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

export function AutocompleteFreeSoloFormField<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
  TValue,
>({
  control,
  name,
  label,
  options,
  noOptionsText,
  disabled,
}: {
  control: Control<TFieldValues>;
  name: TName;
  label: ReactNode;
  options: Array<TValue>;
  noOptionsText?: ReactNode;
  disabled?: boolean;
}) {
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field, fieldState }) => {
        return (
          <Autocomplete
            freeSolo
            autoSelect
            options={options}
            noOptionsText={noOptionsText}
            fullWidth
            value={field.value ?? ""}
            onChange={(_, value) => field.onChange(value)}
            disabled={field.disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="outlined"
                fullWidth
                error={!!fieldState.error}
                helperText={fieldState.error?.message || ""}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            )}
          />
        );
      }}
    />
  );
}
